import axios from "axios";

let backUrl = "https://equios-node-795560498566.asia-south1.run.app";
// let backUrl = "http://localhost:4000";

const adminLogin = async (data) => {
  data.status = "completed";
  const response = await axios.post(`${backUrl}/auth/admin_login`, data);
  return response;
};

const getRiders = async () => {
  const response = await axios.get(`${backUrl}/auth/get_riders`);
  return response;
};

const createRider = async (data) => {
  const response = await axios.post(`${backUrl}/auth/user_register`, data);
  return response;
};

const getHourse = async () => {
  const response = await axios.get(`${backUrl}/user/get_horses`);
  return response;
};

const createHourse = async (data) => {
  const response = await axios.post(`${backUrl}/user/create_horse`, data);
  return response;
};

const deleteHourse = async (data) => {
  const response = await axios.delete(
    `${backUrl}/user/delete_horse?id=${data?.id}`
  );
  return response;
};

const updateHourse = async (id, data) => {
  const response = await axios.put(`${backUrl}/user/update_horse`, data);
  return response;
};

const deleteRider = async (data) => {
  const response = await axios.delete(`${backUrl}/user/delete_user?id=${data}`);
  return response;
};

const updateRider = async (data) => {
  const response = await axios.put(`${backUrl}/user/update_user`, data);
  return response;
};

const getClubs = async () => {
  const response = await axios.get(`${backUrl}/club/get_all_clubs`);
  return response;
};

const createClub = async (data) => {
  const response = await axios.post(`${backUrl}/club/create_club`, data);
  return response;
};

const uploadImage = async (data) => {
  const response = await axios.post(`${backUrl}/user/upload_file`, data);
  return response;
};

const getClubEvents = async (id) => {
  const response = await axios.get(
    `${backUrl}/event/get_eventByClubId?club_id=${id}`
  );
  return response;
};

const postEvent = async (data) => {
  const response = await axios.post(`${backUrl}/event/create_event`, data);
  return response;
};

const getEventCategory = async (id) => {
  const response = await axios.get(
    `${backUrl}/event/get_eventCategoryByEventId?event_id=${id}`
  );
  return response;
};

const createEventCategory = async (data) => {
  const response = await axios.post(
    `${backUrl}/event/create_eventCategory`,
    data
  );
  return response;
};

const updateEventCategory = async (data) => {
  const response = await axios.patch(
    `${backUrl}/event/update_eventCategory`,
    data
  );
  return response;
};

const getCategoryResults = async (id) => {
  const response = await axios.get(
    `${backUrl}/event/get_eventResultByEventId?category_id=${id}`
  );
  return response;
};

const getCategoryResultsWithoutAnalytics = async (id) => {
  const response = await axios.get(
    `${backUrl}/event/get_eventResultByRiderId_without_analysis?category_id=${id}`
  );
  return response;
};

const addCategoryResult = async (data) => {
  const response = await axios.post(
    `${backUrl}/event/create_eventResult`,
    data
  );
  return response;
};

const updateCategoryResult = async (data) => {
  const response = await axios.patch(
    `${backUrl}/event/update_eventResult`,
    data
  );
  return response;
};

const getHorseResults = async (id) => {
  const response = await axios.get(
    `${backUrl}/event/get_eventResultByHorseId?horse_id=${id}`
  );
  return response;
};

const getRiderResults = async (id) => {
  const response = await axios.get(
    `${backUrl}/event/get_eventResultByHorseId?rider_id=${id}`
  );
  return response;
};

const getCalendar = async () => {
  const response = await axios.get(`${backUrl}/event/get_calendar`);
  return response;
};

const createCalendar = async (data) => {
  const response = await axios.post(`${backUrl}/event/create_calendar`, data);
  return response;
};

const update_event = async (data) => {
  const response = await axios.patch(`${backUrl}/event/update_event`, data);
  return response;
};

const updateCalendar = async (data) => {
  const response = await axios.patch(`${backUrl}/event/update_calendar`, data);
  return response;
};

const getAllUsers = async () => {
  const response = await axios.get(`${backUrl}/user/get_all_users`);
  return response;
};

const updateClub = async (data) => {
  const response = await axios.patch(`${backUrl}/club/update_club`, data);
  return response;
};

const deleteClub = async (data) => {
  const response = await axios.delete(
    `${backUrl}/club/delete_club?id=${data?.id}`
  );
  return response;
};

const deleteEventCategory = async (data) => {
  const response = await axios.delete(
    `${backUrl}/event/delete_eventCategory?id=${data?.id}`
  );
  return response;
};

const deleteResult = async (data) => {
  console.log(data, "12");
  const response = await axios.delete(
    `${backUrl}/event/delete_eventResult?id=${data?.id}`
  );
  return response;
};

const deleteEvent = async (data) => {
  const response = await axios.delete(
    `${backUrl}/event/delete_event?id=${data?.id}`
  );
  return response;
};

const deleteCalendar = async (data) => {
  const response = await axios.delete(
    `${backUrl}/event/delete_calendar?id=${data}`
  );
  return response;
};

const updateUserRole = async (data) => {
  const response = await axios.patch(`${backUrl}/user/update_user_role`, data);
  return response;
};

const DeleteUser = async (data) => {
  const response = await axios.post(`${backUrl}/user/remove_user`, data);
  return response;
};

const uploadSheet = async (data) => {
  const response = await axios.post(`${backUrl}/club/event_result_upload`, data);
  return response;
};

const uploadSheetWithoutAnalytics = async (data) => {
  const response = await axios.post(`${backUrl}/club/event_result_without_analysis`, data);
  return response;
};


const createChampion = async (data) => {
  const response = await axios.post(`${backUrl}/club/create_club_champion`, data);
  return response;
};

const getChampion = async (id) => {
  const response = await axios.get(`${backUrl}/club/get_club_champions?clubid=${id}`);
  return response;
};

const updateChampion = async (data) => {
  const response = await axios.patch(`${backUrl}/club/update_club_champion`, data);
  return response;
};

const deleteChampion = async (id) => {
  const response = await axios.delete(`${backUrl}/club/delete_club_champion?id=${id}`);
  return response;
};

const getMarketPlace = async () => {
  const response = await axios.get(`${backUrl}/marketplace/get_marketplace_listing`);
  return response;
};

const createMarketPlace = async (data) => {
  const response = await axios.post(`${backUrl}/marketplace/create_marketplace_listing`, data);
  return response;
};

const deleteMarketPlace = async (id) => {
  const response = await axios.delete(`${backUrl}/marketplace/delete_marketplace_listing?id=${id}`);
  return response;
};

const updateMarketPlace = async (data) => {
  const response = await axios.patch(`${backUrl}/marketplace/update_marketplace_listing`, data);
  return response;
};

// Analytics API Services
const getUserAnalytics = async (userId, period = 'all') => {
  const response = await axios.get(`${backUrl}/analytics/user/${userId}?period=${period}`);
  return response;
};

const getUserAnalyticsRange = async (userId, startDate, endDate) => {
  const response = await axios.get(`${backUrl}/analytics/user/${userId}/range?startDate=${startDate}&endDate=${endDate}`);
  return response;
};

const getUserAnalyticsStats = async (userId) => {
  const response = await axios.get(`${backUrl}/analytics/user/${userId}/stats`);
  return response;
};

const getAllAnalytics = async (period = 'all') => {
  const response = await axios.get(`${backUrl}/analytics/all?period=${period}`);
  return response;
};

const getTransactions = async () => {
  const response = await axios.get(`${backUrl}/transaction/get_transactions`);
  return response;
};

const deleteUserandUpdate = async (data) => {
  const response = await axios.delete(`${backUrl}/user/delete_user_update`, {
    data: data
  });
  return response;
};

// Video Analytics API Services
const getAllVideoAnalytics = async () => {
  const response = await axios.get(`${backUrl}/video_analytics/get_all`);
  return response;
};

const createVideoAnalytics = async (data) => {
  const response = await axios.post(`${backUrl}/video_analytics/create`, data);
  return response;
};

const getVideoAnalyticsByUser = async (userId) => {
  const response = await axios.get(`${backUrl}/video_analytics/get_by_user?user_id=${userId}`);
  return response;
};

const deleteVideoAnalytics = async (id) => {
  const response = await axios.delete(`${backUrl}/video_analytics/delete?id=${id}`);
  return response;
};

const getUserPoints = async () => {
  const response = await axios.get(`${backUrl}/points/get_user_points`);
  return response;
};

const createSessionPass = async (data) => {
  const response = await axios.post(`${backUrl}/session_pass/create_session_pass`, data);
  return response;
};

const updateSessionPass = async (data) => {
  const response = await axios.put(`${backUrl}/session_pass/update_session_pass`, data);
  return response;
};

const deleteSessionPass = async (id) => {
  const response = await axios.delete(`${backUrl}/session_pass/delete_session_pass?id=${id}`);
  return response;
};

export {
  adminLogin,
  DeleteUser,
  getRiders,
  createRider,
  getHourse,
  createHourse,
  deleteHourse,
  updateHourse,
  deleteRider,
  getClubs,
  updateRider,
  createClub,
  uploadImage,
  uploadSheet,
  uploadSheetWithoutAnalytics,
  getClubEvents,
  postEvent,
  getEventCategory,
  createEventCategory,
  getCategoryResults,
  getCategoryResultsWithoutAnalytics,
  addCategoryResult,
  getHorseResults,
  getRiderResults,
  getCalendar,
  createCalendar,
  update_event,
  updateCalendar,
  updateClub,
  updateEventCategory,
  getAllUsers,
  updateCategoryResult,
  deleteClub,
  deleteEventCategory,
  deleteResult,
  deleteEvent,
  deleteCalendar,
  updateUserRole,
  createChampion,
  getChampion,
  updateChampion,
  deleteChampion,
  getMarketPlace,
  createMarketPlace,
  deleteMarketPlace,
  updateMarketPlace,
  getUserAnalytics,
  getUserAnalyticsRange,
  getUserAnalyticsStats,
  getAllAnalytics,
  deleteUserandUpdate,
  getTransactions,
  getAllVideoAnalytics,
  createVideoAnalytics,
  getVideoAnalyticsByUser,
  deleteVideoAnalytics,
  getUserPoints,
  createSessionPass,
  updateSessionPass,
  deleteSessionPass
};
